import { Alert, Image, Loader } from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import QRCodeGen from "qrcode";
import type { FC } from "react";
import { useEffect, useState } from "react";

interface QRCodeProps {
  url: string;
  size?: number;
}

const errorIcon = <IconExclamationCircle />;
const qrCode = "QR code fro map";
export const QRCode: FC<QRCodeProps> = ({ url, size = 200 }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (url) {
      setLoading(true);
      void QRCodeGen.toDataURL(url, {
        width: size,
        margin: 1,
      })
        .then(setQrCodeUrl)
        .catch(setError)
        .finally(() => { setLoading(false); });
    }
  }, [url, size]);

  if (loading) {
    return (<Loader />);
  }

  if (error) {
    return (
      <Alert
        variant="light"
        color="red"
        icon={errorIcon}
        title={error.message}
      />
    );
  }
  else {
    return (
      <Image
        src={qrCodeUrl}
        alt={qrCode}
        w={size}
        h={size}
      />
    );
  }
};
